import React from 'react'
import { auth } from '../firebase-config'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { useFormik } from 'formik'
import { object, string } from 'yup'
import { Navigate } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { Button } from '../components/Button'
import { Input } from '../components/Input'
import { Error } from '../components/Error'
import stylesUserSignUp from './UserSignUp.module.css'
import styles from '../components/Button.module.css'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const requiredMsg = 'Dieses Feld ist verpflichtend'

const userSchema = object({
  email: string().email('Muss eine gültige E-Mail sein').required(requiredMsg),
  password: string().min(7, 'mindestens 7 Zeichen').required(requiredMsg),
})

const initialValues = {
  email: '',
  password: '',
}

async function handleSubmit(email, password) {
  try {
    await signInWithEmailAndPassword(auth, email, password)
  } catch {
    toast.error(
      'Leider konnten wir deine Eingaben nicht verarbeiten. Bitte versuche es erneut.',
      {
        position: 'top-center',
      },
    )
  }
}

export const UserSignIn = ({ user, onSubmit = handleSubmit }) => {
  const formik = useFormik({
    initialValues,
    validationSchema: userSchema,
    onSubmit: (values) => onSubmit(values.email, values.password),
  })

  if (user) return <Navigate to="/#myshop"></Navigate>

  return (
    <>
    <form
      className={stylesUserSignUp.usersignup}
      onSubmit={formik.handleSubmit}
    >
      <div>
        <Input
          name='email'
          type='email'
          label='E-Mail'
          placeholder='mustershop@email.com'
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
          required={true}
        />
        {formik.touched.email && formik.errors.email && (
          <Error msg={formik.errors.email} />
        )}
      </div>

      <div>
        <Input
          name='password'
          type='password'
          label='Passwort'
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.password}
        />
        {formik.touched.password && formik.errors.password && (
          <Error msg={formik.errors.password} />
        )}
      </div>
      <Button type='submit'>Anmelden</Button>
    </form>

    <Link to="/password-reset" className={styles.passwordReset}><Button>Passwort vergessen</Button></Link>
    </>
  )
}
